"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.close = exports.open = exports.get = void 0;
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueStats_sidecar_1 = require("./rogueStats-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: false,
        };
    }
    return _obj;
};
exports.get = get;
var open = function () {
    var obj = (0, exports.get)();
    obj.isOpen = true;
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Messages');
    y++;
    var messages = rogueStats_sidecar_1.rogueStats.getStats().messages;
    for (var i = 0; i < messages.length; i++) {
        var item = messages[messages.length - i - 1]; // Reverse order
        y++;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, item);
    }
};
exports.drawAll = drawAll;
